module.exports = __webpack_public_path__ + "static/media/campsite.4fd39225.png";